module.exports = __webpack_public_path__ + "img/reddit.e03328ce.svg";